<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<!-- Header -->
<div class="cssLayoutRowStartCenter">
  <div class="sp-icon" style="margin-right: 10px;">
    <mat-icon class="mdi-24px" fontIcon="mdi-clipboard-list-outline" [ngStyle]="{'color': 'var(--mat-sys-primary)'}"></mat-icon>
  </div>
  <button mat-icon-button (click)="addOrEditAction(null)" style="outline: none; margin-left: 20px;" title="Add Action"
    [disabled]="!selectedEvaluationId || !canEdit">
    <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
  </button>
  <mat-form-field class="button-margins">
    <mat-label>Move</mat-label>
    <mat-select placeholder="Move" [value]="selectedMoveNumber.toString()" (selectionChange)="selectMove($event.value)">
      <mat-option value="{{ allMovesValue }}">All Moves</mat-option>
      @for (move of moveList; track move.id) {
      <mat-option [value]="move.moveNumber">
        {{ move.moveNumber }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="button-margins team-selector">
    <mat-label>Team</mat-label>
    <mat-select placeholder="Team" [value]="selectedTeamId" (selectionChange)="selectTeam($event.value)">
      <mat-option value="">All Teams</mat-option>
      @for (team of teamList; track team.id) {
      <mat-option [value]="team.id">
        {{ team.name }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="button-margins search-field">
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
      <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
</div>

<!-- Table -->
<div class="table-container elevate">
  <table mat-table [dataSource]="dataSource" matSort>
    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header><span style="margin-left: 80px;">Description</span></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button (click)="addOrEditAction(row); $event.stopPropagation()" title="Edit Action"
          [disabled]="!canEdit">
          <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline">
          </mat-icon>
        </button>
        <button mat-icon-button class="button-end" (click)="deleteActionRequest(row); $event.stopPropagation()"
          title="Delete Action" [disabled]="!canEdit">
          <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"></mat-icon>
        </button>
        {{ row.description }}
      </td>
    </ng-container>

    <!-- Move Column -->
    <ng-container matColumnDef="moveNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Move</th>
      <td mat-cell *matCellDef="let row">
        {{ row.moveNumber }}
      </td>
    </ng-container>

    <!-- Team Column -->
    <ng-container matColumnDef="teamId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Team</th>
      <td mat-cell *matCellDef="let row">
        {{ getTeamName(row.teamId) }}
      </td>
    </ng-container>

    <!-- isChecked Column -->
    <ng-container matColumnDef="isChecked">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Checked</th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox [(ngModel)]="row.isChecked" disabled="true"></mat-checkbox>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="4">No matching data</td>
    </tr>
  </table>
</div>

<!-- Loading Indicator -->
@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
